import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['active', 'inactive'];

  start() {
    this.activeTarget.style.display = 'block';
    this.inactiveTarget.style.display = 'none';
  }

  stop() {
    this.activeTarget.style.display = 'none';
    this.inactiveTarget.style.display = 'block';
  }
}
